/**
 Return the points in a quadtree residing within a rectangle.
 @param {Object} quadtree - The quadtree.
 @param {NumberWidget} x0 - The lower x bound of the rectangle.
 @param {NumberWidget} y0 - The lower y bound of the rectangle.
 @param {NumberWidget} x3 - The upper x bound of the rectangle.
 @param {NumberWidget} y3 - The upper y bound of the rectangle.
 @return {Array.<*>} The found points.
 */
function searchQuadtree(quadtree, x0, y0, x3, y3) {
  let p;
  let x;
  let y;
  const found = [];
  const xAccessor = quadtree.x();
  const yAccessor = quadtree.y();
  quadtree.visit((node, x1, y1, x2, y2) => {
    if (!node.length) {
      // eslint-disable-next-line no-cond-assign
      do {
        p = node.data;
        x = xAccessor(p);
        y = yAccessor(p);
        if ((x >= x0) && (x < x3) && (y >= y0) && (y < y3)) found.push(p);
      }
      while (node = node.next); // eslint-disable-line
    }
    return x1 >= x3 || y1 >= y3 || x2 < x0 || y2 < y0;
  });
  return found;
}

/**
 Return the points under the mouse.
 @param {NumberWidget} [mouseX] - The x mouse position.
 @param {NumberWidget} [mouseY] - The y mouse position.
 @param {NumberWidget} [tolerance=0] - Tolerance for finding the points.
 @return {Array.<Object>} The points under the mouse.
 */
function findPoints(quadtree, mouseX, mouseY, tolerance = 0) {
  // There are two types of searches to perform: A point-to-point search and
  // a line-to-point search. The latter is a little more complicated.
  if (typeof mouseX === 'number' && typeof mouseY === 'number') {
    const result = quadtree.find(mouseX, mouseY, tolerance);
    return result ? [result] : [];
  }
  if (typeof mouseX === 'number') {
    const x0 = mouseX - tolerance;
    const x3 = mouseX + tolerance;
    const y0 = -Infinity;
    const y3 = Infinity;
    return searchQuadtree(quadtree, x0, y0, x3, y3);
  }
  if (typeof mouseY === 'number') {
    const x0 = -Infinity;
    const x3 = Infinity;
    const y0 = mouseY - tolerance;
    const y3 = mouseY + tolerance;
    return searchQuadtree(quadtree, x0, y0, x3, y3);
  }

  return [];
}

export default findPoints;
